import { Button as AntdButton } from "antd";
import { ButtonProps as AntdButtonProps } from "antd/lib/button";
import React from "react";

export type MyButtonProps = AntdButtonProps;

export interface ButtonStaticMethods {
  Group: typeof AntdButton.Group;
}

const ButtonPolyfill: React.FC<MyButtonProps> & ButtonStaticMethods = (
  props,
) => {
  return <AntdButton {...props} />;
};

ButtonPolyfill.Group = AntdButton.Group;

export default ButtonPolyfill;
